<span *ngIf="claimService.lossType == lossType.Disability">
    <p-steps class="claim-steps" [model]="claimStepsService.disabilitySteps" [(activeIndex)]="claimStepsService.index"></p-steps>
</span>
<span *ngIf="claimService.lossType == lossType.Unemployment">
    <p-steps class="claim-steps claim-steps-u" [model]="claimStepsService.unemploymentSteps" [(activeIndex)]="claimStepsService.index"></p-steps>
</span>
